const TEAM = {
  Akshi: {
    name: 'Akshi',
    image: '/images/team/akshi.jpg',
  },
  Archie: {
    name: 'Archie',
    image: '/images/team/archie.jpg',
  },
  Chloe: {
    name: 'Chloe',
    image: '/images/team/chloe.jpg',
  },
  Curran: {
    name: 'Curran',
    image: '/images/team/curran.jpg',
  },
  Digby: {
    name: 'Digby',
    image: '/images/team/digby.jpg',
  },
  Eddie: {
    name: 'Eddie',
    image: '/images/team/eddie.jpg',
  },
  George: {
    name: 'George',
    image: '/images/team/george.jpg',
  },
  Hebe: {
    name: 'Hebe',
    image: '/images/team/hebe.jpg',
  },
  Hugo: {
    name: 'Hugo',
    image: '/images/team/hugo.jpg',
  },
  Immy: {
    name: 'Immy',
    image: '/images/team/immy.jpg',
  },
  Jack: {
    name: 'Jack',
    image: '/images/team/jack.jpg',
  },
  Jaya: {
    name: 'Jaya',
    image: '/images/team/jaya.jpg',
  },
  Laurence: {
    name: 'Laurence',
    image: '/images/team/laurence.jpg',
  },
  Lovisa: {
    name: 'Lovisa',
    image: '/images/team/lovisa.jpg',
  },
  Mel: {
    name: 'Mel',
    image: '/images/team/mel.jpg',
  },
  Mia: {
    name: 'Mia',
    image: '/images/team/mia.jpg',
  },
  Miles: {
    name: 'Miles',
    image: '/images/team/miles.jpg',
  },
  Minnie: {
    name: 'Minnie',
    image: '/images/team/minnie.jpg',
  },
  Phil: {
    name: 'Phil',
    image: '/images/team/phil.jpg',
  },
  Rebecca: {
    name: 'Rebecca',
    image: '/images/team/rebecca.jpg',
  },
  Rory: {
    name: 'Rory',
    image: '/images/team/rory.jpg',
  },
  Seb: {
    name: 'Seb',
    image: '/images/team/seb.jpg',
  },
  Susannah: {
    name: 'Susannah',
    image: '/images/team/susannah.jpg',
  },
  Victoria: {
    name: 'Victoria',
    image: 'https://assets.feast-it.com/am-victoria.jpg',
  },
};

export default TEAM;
